export default __webpack_public_path__ + "static/media/loading-transparent.a54ed775.png";